import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

const API_URL = process.env.REACT_APP_BACKEND_URL

// Klucze do cache
export const tileKeys = {
  all: ['tiles'],
  userTiles: (userId) => [...tileKeys.all, userId],
};

// Pobieranie kafelków użytkownika
export function useTiles() {
  return useQuery({
    queryKey: ['tiles'],
    queryFn: async () => {
      const token = localStorage.getItem('access_token');
      const response = await fetch(`${API_URL}/api/dashboard/tiles/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error('Błąd podczas pobierania kafelków');
      return response.json();
    },
    enabled: true,
  });
}

// Mutacja do aktualizacji kolejności kafelków
export function useUpdateTileOrder(userId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (tileIds) => {
      const token = localStorage.getItem('access_token');
      const response = await fetch(`${API_URL}/api/dashboard/update-tile-order/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ tile_ids: tileIds }),
      });
      if (!response.ok) throw new Error('Błąd podczas zapisywania kolejności');
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tileKeys.userTiles(userId) });
    },
  });
}